import { render, staticRenderFns } from "./HTML5QRcode.vue?vue&type=template&id=b8a0a7b8&scoped=true&"
import script from "./HTML5QRcode.vue?vue&type=script&lang=js&"
export * from "./HTML5QRcode.vue?vue&type=script&lang=js&"
import style0 from "./HTML5QRcode.vue?vue&type=style&index=0&id=b8a0a7b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a0a7b8",
  null
  
)

export default component.exports